import { render, staticRenderFns } from "./YinSiMobile.vue?vue&type=template&id=6a8cecf9&"
import script from "./YinSiMobile.vue?vue&type=script&lang=js&"
export * from "./YinSiMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports